export default __webpack_public_path__ + "9d24baee6179606823597815d984413b.svg";